/**
 * Routing Constants
 * Contains configuration constants for route generation
 */

// Storage keys for caching
export const PATHS_STORAGE_KEY = 'admin_paths_cache';
export const PATHS_VERSION_KEY = 'admin_paths_version';

/**
 * Dynamic segment mapping for grouped features
 * Maps parent handle to dynamic segment parameter name or catch-all pattern
 * 
 * String values: dynamic segment name (e.g., 'media' → [media])
 * '...slug' value: catch-all route (e.g., '...slug' → [[...slug]])
 */
export const DYNAMIC_SEGMENT_MAPPING = {
  library: 'media',           // /library/[media] → documents, images, videos, audios
  taxonomy: 'category',       // /taxonomy/[category] → all category types
  reports: 'type',            // /reports/[type] → all report types
  'knowledge-assets': '...slug',  // /knowledge-assets/[[...slug]] → tree-based navigation
};

/**
 * Minimal fallback paths structure
 * Used when no features are loaded
 */
export const FALLBACK_PATHS = {
  index: "/",
  login: "/",
  admin: {
    index: "/admin",
  },
  notAuthorized: "/401",
  forbidden: "/403",
  notFound: "/404",
  serverError: "/500",
};
